import { render, staticRenderFns } from "./duration-type-setting.vue?vue&type=template&id=8f03da44"
import script from "./duration-type-setting.vue?vue&type=script&lang=js"
export * from "./duration-type-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports